/* ============================================================
   Canadian Laser Supply — Theme JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── STICKY HEADER ── */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── MOBILE NAV ── */
  var toggle    = document.querySelector('.mobile-menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileClose = document.querySelector('.mobile-nav-close');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () { mobileNav.classList.add('open'); });
    if (mobileClose) mobileClose.addEventListener('click', function () { mobileNav.classList.remove('open'); });
    mobileNav.addEventListener('click', function (e) {
      if (e.target === mobileNav) mobileNav.classList.remove('open');
    });

    /* Submenu accordions */
    mobileNav.querySelectorAll('.mobile-nav-sub-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var group = btn.closest('.mobile-nav-group');
        if (!group) return;
        var isOpen = group.classList.toggle('sub-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  /* ── MOBILE SEARCH TOGGLE ── */
  var searchToggle = document.querySelector('.header-search-toggle');
  var mobileSearch = document.getElementById('mobile-search');
  if (searchToggle && mobileSearch) {
    var searchField = mobileSearch.querySelector('input[type="search"]');
    searchToggle.addEventListener('click', function () {
      var isOpen = mobileSearch.classList.toggle('open');
      searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen && searchField) {
        setTimeout(function () { searchField.focus(); }, 60);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileSearch.classList.contains('open')) {
        mobileSearch.classList.remove('open');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ── MONEY FORMAT (shared) ── */
  function formatMoney(cents) {
    var fmt = window.shopMoneyFormat || '${{amount}}';
    var dollars = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount}}', dollars)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', dollars.replace('.', ','));
  }

  /* ── CART DRAWER ── */
  var cartOverlay = document.getElementById('cart-overlay');
  var cartDrawer  = document.getElementById('cart-drawer');
  var cartClose   = document.getElementById('cart-close');
  var cartBody    = document.getElementById('cart-drawer-body');
  var cartFooter  = document.getElementById('cart-drawer-footer');
  var cartSubtotal = document.getElementById('cart-subtotal-price');

  function openCart() {
    renderCart();
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer)  cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer)  cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Update header count badge */
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });

        if (cart.item_count === 0) {
          cartBody.innerHTML =
            '<div class="cart-empty-state">' +
            '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
            '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
            '<line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
            '<h3>Your cart is empty</h3>' +
            '<p>Add some laser supplies to get started!</p>' +
            '<a href="/collections/all" class="btn btn-primary" style="margin-top:20px;display:inline-flex;">Shop Now</a>' +
            '</div>';
          if (cartFooter) cartFooter.style.display = 'none';
          return;
        }

        /* Build items HTML */
        var html = '';
        cart.items.forEach(function (item, idx) {
          var imgSrc = item.image ? item.image.replace('.jpg', '_150x150.jpg').replace('.png', '_150x150.png') : '';
          var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<div class="cart-item-variant">' + item.variant_title + '</div>'
            : '';
          /* Line item properties (e.g. uploaded design link) */
          if (item.properties) {
            Object.keys(item.properties).forEach(function (key) {
              var val = item.properties[key];
              if (!val || key.charAt(0) === '_') return;
              var display = (typeof val === 'string' && val.indexOf('http') === 0)
                ? '<a href="' + val + '" target="_blank" rel="noopener" style="color:var(--cls-orange);">View file</a>'
                : val;
              variantLine += '<div class="cart-item-variant">' + key + ': ' + display + '</div>';
            });
          }
          html +=
            '<div class="cart-item">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '" class="cart-item-img">' : '') +
              '<div class="cart-item-body">' +
                '<a href="' + item.url + '" class="cart-item-title">' + item.product_title + '</a>' +
                variantLine +
                '<div class="cart-item-footer">' +
                  '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
                  '<button class="cart-item-remove" data-line="' + (idx + 1) + '">Remove</button>' +
                '</div>' +
              '</div>' +
            '</div>';
        });
        cartBody.innerHTML = html;

        /* Remove buttons */
        cartBody.querySelectorAll('.cart-item-remove').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var line = btn.dataset.line;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
            }).then(function () { renderCart(); });
          });
        });

        /* Footer */
        if (cartFooter) cartFooter.style.display = 'block';
        if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
      })
      .catch(function (err) { console.error('Cart fetch error', err); });
  }

  document.querySelectorAll('[data-cart-trigger]').forEach(function (t) {
    t.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* Initial cart count */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    }).catch(function () {});

  /* ── ADD TO CART ── */
  document.querySelectorAll('[data-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      /* Custom upload field (product.custom-upload template) */
      if (window.clsUpload && window.clsUpload.required && !window.clsUpload.value) {
        window.clsUpload.showError();
        return;
      }

      var qtyInput = document.querySelector('.qty-input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var payload = { id: parseInt(variantId, 10), quantity: qty };
      if (window.clsUpload && window.clsUpload.value) {
        payload.properties = {};
        payload.properties[window.clsUpload.propertyName] = window.clsUpload.value;
      }

      btn.disabled = true;
      var original = btn.innerHTML;
      btn.innerHTML = 'Adding&hellip;';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        if (res.ok) {
          btn.innerHTML = '&#10003; Added!';
          btn.style.background = '#38A169';
          setTimeout(function () {
            btn.innerHTML = original;
            btn.style.background = '';
            btn.disabled = false;
          }, 1600);
          openCart(); /* renders fresh cart */
        } else {
          return res.json().then(function (data) {
            btn.innerHTML = data.description || 'Out of Stock';
            btn.style.background = '#E53E3E';
            setTimeout(function () { btn.innerHTML = original; btn.style.background = ''; btn.disabled = false; }, 2200);
          });
        }
      })
      .catch(function () {
        btn.innerHTML = original;
        btn.disabled = false;
      });
    });
  });

  /* ── VARIANT SELECTION (product page) ── */
  /* Use /products/handle.js for live inventory — never the Liquid-rendered JSON */
  var numOptions = window.productNumOptions || 0;

  if (numOptions > 0 && window.productHandle) {

    var variants       = null;
    var selectedOptions = [];

    function findVariant(opts) {
      if (!variants) return null;
      return variants.find(function (v) {
        for (var j = 0; j < numOptions; j++) {
          if (v['option' + (j + 1)] !== opts[j]) return false;
        }
        return true;
      }) || null;
    }

    function updatePrice(variant) {
      var priceEl   = document.getElementById('price-current');
      var compareEl = document.getElementById('price-compare');
      var atcBtn    = document.getElementById('btn-atc');

      if (!variant) {
        if (priceEl)   priceEl.textContent = 'Unavailable';
        if (compareEl) compareEl.style.display = 'none';
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Unavailable';
          atcBtn.style.background = 'var(--cls-gray)';
          atcBtn.style.cursor = 'not-allowed';
        }
        return;
      }

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.className   = 'price' + (variant.compare_at_price > variant.price ? ' price-sale' : '');
      }
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent   = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (atcBtn) {
        atcBtn.dataset.variantId = String(variant.id);
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.style.background = '';
          atcBtn.style.cursor     = '';
          atcBtn.innerHTML =
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
            '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>' +
            '<line x1="3" y1="6" x2="21" y2="6"/>' +
            '<path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart';
        } else {
          atcBtn.disabled = true;
          atcBtn.style.background = 'var(--cls-gray)';
          atcBtn.style.cursor     = 'not-allowed';
          atcBtn.textContent      = 'Sold Out';
        }
      }

      /* ── Swap gallery image to this variant's assigned image ── */
      if (variant.featured_image && variant.featured_image.src) {
        var vSrc  = variant.featured_image.src;
        var vBase = vSrc.split('?')[0];
        var curImg = document.querySelector('#main-product-image');
        var curBase = curImg && curImg.src ? curImg.src.split('?')[0] : '';
        /* Only swap when the image actually changes (option like thickness
           may share the same image — avoid pointless fade) */
        if (vBase !== curBase) {
          var sized = vSrc + (vSrc.indexOf('?') > -1 ? '&' : '?') + 'width=900';
          galleryShowImage(sized);
        }
        /* Sync thumbnail highlight to the variant image */
        document.querySelectorAll('.product-thumb[data-type="image"]').forEach(function (t) {
          var tBase = t.dataset.src ? t.dataset.src.split('?')[0] : '';
          t.classList.toggle('active', tBase === vBase);
        });
      }
    }

    function handleOptionChange(optionIndex, value) {
      selectedOptions[optionIndex] = value;

      /* Update label */
      var labelEl = document.getElementById('option-label-' + optionIndex);
      if (labelEl) labelEl.textContent = value;

      /* Highlight active swatch/chip in this group only */
      var group = document.querySelector('[data-option-group="' + optionIndex + '"]');
      if (group) {
        group.querySelectorAll('.swatch-lg, .size-chip').forEach(function (el) {
          el.classList.toggle('active', el.dataset.value === value);
        });
      }

      updatePrice(findVariant(selectedOptions));
    }

    /* Attach click handlers straight away — variants may not be loaded yet,
       handleOptionChange guards with findVariant returning null safely */
    document.querySelectorAll('[data-option].swatch-lg, [data-option].size-chip').forEach(function (el) {
      el.addEventListener('click', function () {
        var optIdx = parseInt(el.dataset.option, 10);
        if (isNaN(optIdx)) return;
        handleOptionChange(optIdx, el.dataset.value);
      });
    });

    /* ── Fetch live variant data from Shopify storefront ── */
    fetch('/products/' + window.productHandle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product.js fetch failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        variants = data.variants;

        /* Initialize selectedOptions from the URL-selected (or first available) variant */
        var initVar = variants.find(function (v) { return v.id === window.currentVariantId; });
        if (!initVar) initVar = variants.find(function (v) { return v.available; });
        if (!initVar) initVar = variants[0];

        for (var i = 0; i < numOptions; i++) {
          selectedOptions[i] = initVar['option' + (i + 1)];
        }

        /* Sync initial display to what's actually available */
        updatePrice(initVar);
      })
      .catch(function (err) {
        console.warn('Canadian Laser Supply theme: variant fetch failed.', err);
      });

  } /* end variant block */

  /* ── PRODUCT GALLERY THUMBNAILS (images + video) ── */
  var mainImg = document.querySelector('#main-product-image');
  var mainVideo = document.querySelector('#main-product-video');

  function galleryShowImage(src) {
    if (mainVideo) {
      mainVideo.pause();
      mainVideo.classList.remove('is-visible');
    }
    if (mainImg && src) {
      mainImg.style.opacity = '0';
      mainImg.style.transition = 'opacity 0.2s';
      setTimeout(function () { mainImg.src = src; mainImg.style.opacity = '1'; }, 200);
    }
  }

  function galleryShowVideo(src) {
    if (!mainVideo) return;
    mainVideo.classList.add('is-visible');
    if (mainVideo.getAttribute('src') !== src) {
      mainVideo.src = src;
      mainVideo.load();
    }
    var p = mainVideo.play();
    if (p && p.catch) p.catch(function () {});
  }

  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    var activate = function () {
      document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (thumb.dataset.type === 'video' && thumb.dataset.videoSrc) {
        galleryShowVideo(thumb.dataset.videoSrc);
      } else if (thumb.dataset.src) {
        galleryShowImage(thumb.dataset.src);
      }
    };
    thumb.addEventListener('click', activate);
    thumb.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
    });
  });

  /* ── PRODUCT CARD SWATCHES ── */
  document.querySelectorAll('.product-card .swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var swatches = sw.closest('.product-swatches');
      if (swatches) swatches.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      var img = sw.closest('.product-card') ? sw.closest('.product-card').querySelector('.product-card-image img') : null;
      if (img && sw.dataset.img) img.src = sw.dataset.img;
    });
  });

  /* ── QUANTITY SELECTOR ── */
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var input = sel.querySelector('.qty-input');
    var minus = sel.querySelector('.qty-minus');
    var plus  = sel.querySelector('.qty-plus');
    if (minus && input) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    if (plus && input) plus.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ── SCROLL REVEAL ── */
  if ('IntersectionObserver' in window) {
    var revealEls = document.querySelectorAll('.product-card, .category-card, .subcat-tile, .trust-badge');
    var io = new IntersectionObserver(function (entries) {
      // Stagger only within the batch that just came into view, capped at 0.2s,
      // so cards deep in the page never sit invisible while you scroll.
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var delay = Math.min(i * 0.05, 0.2);
          entry.target.style.transitionDelay = delay + 's';
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px 200px 0px' });
    revealEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.45s ease, transform 0.45s ease';
      io.observe(el);
    });
  }

  /* ── PRODUCT CARD HOVER MEDIA (video or GIF) ──
     Desktop: plays on hover.
     Touch devices (no hover): after scrolling settles, the ONE card closest
     to the viewport center auto-plays; it pauses when scrolled away.
     Media is never downloaded until the moment it's first needed. */
  (function () {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.product-card.has-hover-media'));
    if (!cards.length) return;

    function getMedia(card) { return card.querySelector('.product-card-hover-media'); }

    function loadMedia(card) {
      var media = getMedia(card);
      if (!media || media.dataset.loaded) return;
      media.dataset.loaded = '1';
      var onReady = function () { card.classList.add('media-ready'); };
      if (media.tagName === 'VIDEO') {
        media.addEventListener('canplay', onReady, { once: true });
        media.src = media.getAttribute('data-video-src');
        media.load();
      } else {
        media.addEventListener('load', onReady, { once: true });
        media.src = media.getAttribute('data-gif-src');
      }
    }

    function playCard(card) {
      loadMedia(card);
      card.classList.add('media-playing');
      var media = getMedia(card);
      if (media && media.tagName === 'VIDEO') {
        var p = media.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function stopCard(card) {
      card.classList.remove('media-playing');
      var media = getMedia(card);
      if (media && media.tagName === 'VIDEO' && media.dataset.loaded) {
        media.pause();
        media.currentTime = 0;
      }
    }

    var touchMode = window.matchMedia('(hover: none)').matches;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!touchMode) {
      /* Desktop: hover to play */
      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () { playCard(card); });
        card.addEventListener('mouseleave', function () { stopCard(card); });
      });
      return;
    }

    if (reducedMotion || !('IntersectionObserver' in window)) return;

    /* Touch: autoplay the ROW of cards nearest the viewport center.
       In a 2-wide grid both cards of the row play together; cards in
       other rows stay still. */
    var visibleCards = [];
    var currentCards = [];
    var settleTimer = null;
    var SETTLE_MS = 700; /* how long the page must be still before playing */

    function pickAndPlay() {
      var viewportCenter = window.innerHeight / 2;
      var best = null;
      var bestDist = Infinity;
      visibleCards.forEach(function (card) {
        var r = card.getBoundingClientRect();
        var dist = Math.abs(r.top + r.height / 2 - viewportCenter);
        if (dist < bestDist) { bestDist = dist; best = card; }
      });

      var next = [];
      if (best) {
        var bestRect = best.getBoundingClientRect();
        var bestCenter = bestRect.top + bestRect.height / 2;
        visibleCards.forEach(function (card) {
          var r = card.getBoundingClientRect();
          var center = r.top + r.height / 2;
          /* Same row = vertical centers within half a card height */
          if (Math.abs(center - bestCenter) < r.height * 0.5) next.push(card);
        });
      }

      currentCards.forEach(function (card) {
        if (next.indexOf(card) === -1) stopCard(card);
      });
      next.forEach(function (card) {
        if (currentCards.indexOf(card) === -1) playCard(card);
      });
      currentCards = next;
    }

    function schedule() {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(pickAndPlay, SETTLE_MS);
    }

    var mediaObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        var idx = visibleCards.indexOf(card);
        if (entry.isIntersecting) {
          if (idx === -1) visibleCards.push(card);
        } else {
          if (idx > -1) visibleCards.splice(idx, 1);
          var cIdx = currentCards.indexOf(card);
          if (cIdx > -1) { stopCard(card); currentCards.splice(cIdx, 1); }
        }
      });
      schedule();
    }, { threshold: 0.6 });

    cards.forEach(function (card) { mediaObserver.observe(card); });
    window.addEventListener('scroll', schedule, { passive: true });

    /* Pause when tab is hidden */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        currentCards.forEach(stopCard);
        currentCards = [];
      } else {
        schedule();
      }
    });
  })();

});

